import axios from "@/request";
import qs from "qs";

export default {
  async list(params: any) {
    return axios.get("stadiumcrm/attence/list", { params });
  },
  async loglist(params: any) {
    return axios.get("stadiumcrm/attencelog/list", { params });
  },
  async statistics(params: any) {
    return axios.get("stadiumcrm/statistics/index", { params });
  }
};
